// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file api/v1/common.proto (package journal.api.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file api/v1/common.proto.
 */
export const file_api_v1_common: GenFile = /*@__PURE__*/
  fileDesc("ChNhcGkvdjEvY29tbW9uLnByb3RvEg5qb3VybmFsLmFwaS52MSIqCglQYWdlVG9rZW4SDQoFbGltaXQYASABKAUSDgoGb2Zmc2V0GAIgASgFKjgKBVN0YXRlEhUKEVNUQVRFX1VOU1BFQ0lGSUVEEAASCgoGTk9STUFMEAESDAoIQVJDSElWRUQQAio5CglEaXJlY3Rpb24SGQoVRElSRUNUSU9OX1VOU1BFQ0lGSUVEEAASBwoDQVNDEAESCAoEREVTQxACQrABChJjb20uam91cm5hbC5hcGkudjFCC0NvbW1vblByb3RvUAFaM2dpdGh1Yi5jb20veGluZ2h1aS92YWx1YXRpb24vcHJvdG8vZ2VuL2FwaS92MTthcGl2MaICA0pBWKoCDkpvdXJuYWwuQXBpLlYxygIOSm91cm5hbFxBcGlcVjHiAhpKb3VybmFsXEFwaVxWMVxHUEJNZXRhZGF0YeoCEEpvdXJuYWw6OkFwaTo6VjFiBnByb3RvMw");

/**
 * Used internally for obfuscating the page token.
 *
 * @generated from message journal.api.v1.PageToken
 */
export type PageToken = Message<"journal.api.v1.PageToken"> & {
  /**
   * @generated from field: int32 limit = 1;
   */
  limit: number;

  /**
   * @generated from field: int32 offset = 2;
   */
  offset: number;
};

/**
 * Describes the message journal.api.v1.PageToken.
 * Use `create(PageTokenSchema)` to create a new message.
 */
export const PageTokenSchema: GenMessage<PageToken> = /*@__PURE__*/
  messageDesc(file_api_v1_common, 0);

/**
 * @generated from enum journal.api.v1.State
 */
export enum State {
  /**
   * @generated from enum value: STATE_UNSPECIFIED = 0;
   */
  STATE_UNSPECIFIED = 0,

  /**
   * @generated from enum value: NORMAL = 1;
   */
  NORMAL = 1,

  /**
   * @generated from enum value: ARCHIVED = 2;
   */
  ARCHIVED = 2,
}

/**
 * Describes the enum journal.api.v1.State.
 */
export const StateSchema: GenEnum<State> = /*@__PURE__*/
  enumDesc(file_api_v1_common, 0);

/**
 * @generated from enum journal.api.v1.Direction
 */
export enum Direction {
  /**
   * @generated from enum value: DIRECTION_UNSPECIFIED = 0;
   */
  DIRECTION_UNSPECIFIED = 0,

  /**
   * @generated from enum value: ASC = 1;
   */
  ASC = 1,

  /**
   * @generated from enum value: DESC = 2;
   */
  DESC = 2,
}

/**
 * Describes the enum journal.api.v1.Direction.
 */
export const DirectionSchema: GenEnum<Direction> = /*@__PURE__*/
  enumDesc(file_api_v1_common, 1);

